const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2,.cls-5{opacity:0.95;font-size:70px;stroke-miterlimit:10;stroke-width:3px;font-family:HelveticaNeue-UltraLight, Helvetica Neue;font-weight:100;letter-spacing:0.03em;}.cls-2,.cls-4{fill:#0b1c4d;}.cls-2{stroke:#0b1c4d;}.cls-3{clip-path:url(#clip-path);}.cls-5,.cls-6{fill:#40c7c0;}.cls-5{stroke:#40c7c0;}"), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 5.5,
  y: 8.8,
  width: 44,
  height: 44
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Sooner_Sqr_Navy_new",
  "data-name": "Sooner Sqr Navy new"
}, /*#__PURE__*/React.createElement("text", {
  className: "cls-2",
  transform: "translate(60.6 48.99) scale(1.31 1)"
}, "sooner"), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 5.74,
  y: -2.01,
  width: 44,
  height: 67.43
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M49.5,32.8V3.57C42,6.71,33,12.17,27,19.25c-9.51,11.14-4.22,17.09,3.28,17.83H29c-.33.68.64,1.25.42,1.66s-.63,1.1-1.08,1.86h0c-9,.07-14.68-9.35-7.57-19.71,6.49-9.46,19.29-18,28.74-23.42H5.5V28.14h0a43.86,43.86,0,0,1,12.63-5h0a17.65,17.65,0,0,0-1.22,3.35A35,35,0,0,0,5.5,30.06V59.19C12.11,56,20.92,51.27,27,44.11,36.55,33,31.25,27,23.75,26.29h0c.33-.67.62-1.24.84-1.66s.62-1.1,1.07-1.86h0c9-.07,14.69,9.34,7.57,19.7-6.18,9-18.73,17.67-27.74,23.05,1,0,44-.6,44-.6V34.62h0a43.91,43.91,0,0,1-13.62,5.6h0a17.91,17.91,0,0,0,1.22-3.35A35.87,35.87,0,0,0,49.5,32.8Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 5.5,
  y: -1.94,
  width: 44,
  height: 68.03
})));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Sooner_Sqr_Turq_new",
  "data-name": "Sooner Sqr Turq new"
}, /*#__PURE__*/React.createElement("text", {
  className: "cls-5",
  transform: "translate(60.6 48.99) scale(1.31 1)"
}, "sooner"), /*#__PURE__*/React.createElement("g", {
  className: "cls-3"
}, /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 5.74,
  y: -2.01,
  width: 44,
  height: 67.43
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M49.5,32.8V3.57C42,6.71,33,12.17,27,19.25c-9.51,11.14-4.22,17.09,3.28,17.83H29c-.33.68.64,1.25.42,1.66s-.63,1.1-1.08,1.86h0c-9,.07-14.68-9.35-7.57-19.71,6.49-9.46,19.29-18,28.74-23.42H5.5V28.14h0a43.86,43.86,0,0,1,12.63-5h0a17.65,17.65,0,0,0-1.22,3.35A35,35,0,0,0,5.5,30.06V59.19C12.11,56,20.92,51.27,27,44.11,36.55,33,31.25,27,23.75,26.29h0c.33-.67.62-1.24.84-1.66s.62-1.1,1.07-1.86h0c9-.07,14.69,9.34,7.57,19.7-6.18,9-18.73,17.67-27.74,23.05,1,0,44-.6,44-.6V34.62h0a43.91,43.91,0,0,1-13.62,5.6h0a17.91,17.91,0,0,0,1.22-3.35A35.87,35.87,0,0,0,49.5,32.8Z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 5.5,
  y: -1.94,
  width: 44,
  height: 68.03
})));
function SvgSoonerLogoText(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 333.33 62.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _ref2, title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sooner logo text turquoise") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoonerLogoText);
export default __webpack_public_path__ + "static/media/sooner-logo-text.465f1e7170f6fa98cc19703da4496e3c.svg";
export { ForwardRef as ReactComponent };